import { mapActions } from 'vuex';
import UTILS from '../utils';

const plugin = {
  methods: {
    ...mapActions({}),
    calcOtherUserCmid(talk) {
      if (talk.type != 1) return 0;
      var cmids = talk.cmids.split(',');
      var userCmid = this.cidToCmid(talk.cid);
      for (var id of cmids) {
        if (id != userCmid) return id;
      }
      console.warn(`there is no other cmid in ${talk.cmids}`);
      return 0;
    },
    getTalkName(talk, cms) {
      if (!talk) return '';
      var other = this.calcOtherUserCmid(talk);
      if (other) {
        if (cms && cms[other]) {
          return this.getCmName(cms[other], talk.cid);
        }
        return '';
      }
      return talk.name;
    },
    getTalkCoverPath(talk, cms) {
      if (!talk) return '';
      var other = this.calcOtherUserCmid(talk);
      if (other) {
        if (cms && cms[other]) {
          return this.getCmCoverPath(cms[other], talk.cid);
        }
        return '/imgs/covers/member/green.jpg';
      }
      if (talk.original_cover) {
        return `/cover/t/${talk.id}/${talk.cover_changed_at}`;
      }
      return this.cMap[talk.cid].cover_path;
    },
    gotoPersonalTalk(oneCmid, otherCmid) {
      var talks = this.$store.state.talk.talks;
      var s = String(oneCmid);
      var o = String(otherCmid);
      for (var talk of talks) {
        if (talk.type != 1) continue;
        var cmids = talk.cmids.split(',');
        if (cmids.indexOf(s) != -1 && cmids.indexOf(o) != -1) {
          var toCid = !this.curCid ? 0 : talk.cid;
          this.$router.push({ name: 'talkDetail', params: { id: toCid, talk_id: talk.id } });
          return true;
        }
      }
      return false;
    },
    mergeAndMoveToTalk(talk) {
      this.mergeStoredTalks(talk);
      var toCid = !this.curCid ? 0 : talk.cid;
      this.$router.push({ name: 'talkDetail', params: { id: toCid, talk_id: talk.id } });
    },
    mergeStoredTalks(talk, oldTid) {
      var removeTid = talk ? 0 : oldTid;
      var merged = false;
      var needRefresh = false;
      var newTs = [];
      var ts = this.$store.state.talk.talks;
      for (var t of ts) {
        if (talk && talk.id == t.id) {
          newTs.push(talk);
          merged = true;
          continue;
        } else if (removeTid == t.id) {
          needRefresh = true;
          continue;
        }
        newTs.push(t);
      }
      if (!merged && talk) {
        newTs.push(talk);
        needRefresh = true;
      }

      this.$store.commit('TALK_REFRESH', { loadFromServer: true, talks: newTs });
    },
  },
};

export default plugin;
